import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

  const routes = [

    { //首页
      path: '/',
      name: 'home',
      component: () => import('../views/home.vue'),
      children: [
        { //首页
          path: '/',
          name: 'Index',
          component: () => import('../views/content/Index.vue'),
        },
        { //第一时间
          path: '/ftime',
          name: 'Ftime',
          component: () => import('../views/content/Ftime.vue')
        },
        { //第一时间详情
          path: '/ftimeinfo',
          name: 'Ftimeinfo',
          component: () => import('../views/content/Ftimeinfo.vue')
        },
        { //天下文章-论文
          path: '/whole',
          name: 'Whole',
          component: () => import('../views/content/Whole.vue')
        },
        { //天下文章详情
          path: '/wholeinfo',
          name: 'Wholeinfo',
          component: () => import('../views/content/Wholeinfo.vue')
        },
        { //人物春秋
          path: '/spandaut',
          name: 'Spandaut',
          component: () => import('../views/content/Spandaut.vue')
        },
        { //人物春秋详情
          path: '/spandautinfo',
          name: 'Spandautinfo',
          component: () => import('../views/content/Spandautinfo.vue')
        },
        { //台海两岸
          path: '/strait',
          name: 'Strait',
          component: () => import('../views/content/Strait.vue')
        },
        { //台海两岸详情
          path: '/straitinfo',
          name: 'Straitinfo',
          component: () => import('../views/content/Straitinfo.vue')
        },
        { //至德纪念堂
          path: '/memorial',
          name: 'Memorial',
          component: () => import('../views/content/Memorial.vue')
        },
        { //至德纪念堂外
          path: '/memorialext',
          name: 'Memorialext',
          component: () => import('../views/content/Memorialext.vue')
        },
        { //至德纪念堂内
          path: '/memorialwith',
          name: 'Memorialwith',
          component: () => import('../views/content/Memorialwith.vue')
        },
        { //联络联谊
          path: '/liaison',
          name: 'Liaison',
          component: () => import('../views/content/Liaison.vue')
        },
        { //联络联谊详情
          path: '/liaisoninfo',
          name: 'Liaisoninfo',
          component: () => import('../views/content/Liaisoninfo.vue')
        },
        { //至德经济
          path: '/economic',
          name: 'Economic',
          component: () => import('../views/content/Economic.vue')
        },
        { //企业详情
          path: '/enterinfo',
          name: 'Enterinfo',
          component: () => import('../views/content/Enterinfo.vue')
        },
        { //经济文章详情
          path: '/econinfo',
          name: 'Econinfo',
          component: () => import('../views/content/Econinfo.vue')
        },
        { //经济文章详情
          path: '/econinfo',
          name: 'Econinfo',
          component: () => import('../views/content/Econinfo.vue')
        },
        { //关于我们
          path: '/about',
          name: 'About',
          component: () => import('../views/content/About.vue')
        },
        { //个人中心消息
          path: '/pernews',
          name: 'Pernews',
          component: () => import('../views/content/Pernews.vue')
        },
        { //个人中心发布
          path: '/perrele',
          name: 'Perrele',
          component: () => import('../views/content/Perrele.vue')
        },
        { //个人中心纪念堂
          path: '/permem',
          name: 'Permem',
          component: () => import('../views/content/Permem.vue')
        },
        { //个人中心我的好友
          path: '/perfriend',
          name: 'Perfriend',
          component: () => import('../views/content/Perfriend.vue')
        },
        { //个人中心至德经济
          path: '/perecon',
          name: 'Perecon',
          component: () => import('../views/content/Perecon.vue')
        },
        { //个人中心基础信息
          path: '/perbasis',
          name: 'Perbasis',
          component: () => import('../views/content/Perbasis.vue')
        },
        { //入驻协议
          path: '/agreement',
          name: 'Agreement',
          component: () => import('../views/content/Agreement.vue')
        },
        
      ]
    },
    { //登录页面
      path: '/login',
      name: 'login',
      component: () => import('../views/login.vue')
    },
    { //忘记密码页
      path: '/forgotpassword',
      name: 'Forgotpassword',
      component: () => import('../views/Forgotpassword.vue')
    },
    { //注册页
      path: '/register',
      name: 'Register',
      component: () => import('../views/Register.vue')
    }
  ]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savePosition) {
    // return 期望滚动到哪个的位置
    return {
      y: 0,
    };
  },
})

export default router
